import { render, staticRenderFns } from "./stadium.vue?vue&type=template&id=d0a7a698&"
import script from "./stadium.vue?vue&type=script&lang=ts&"
export * from "./stadium.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports